import { useCallback, useState } from 'react';
import moment, { Moment } from 'moment';
import { request } from '../common/request';
import { strToMoment } from '../common/date';

interface IApiKeyDto {
  id: string;
  name: string;
  description: string;
  activeTo?: string;
  keyId: string;
  keySecret: string;
}

export interface IApiKey extends IApiKeyDto {
  active: boolean;
}

export function useApiKeys() {
  const [apiKeys, setApiKeys] = useState<IApiKey[]>([]);

  const getApiKeys = useCallback(
    () => {
      request.get<{ data: IApiKeyDto[] }>('/api-keys')
        .then(response => {
          const now = moment();
          const apiKeys = response.data.data.map(item => ({
            ...item,
            active: isActive(item.activeTo, now)
          }));

          return setApiKeys(apiKeys);
        })
        .catch(() => { })
    }, []
  );

  const addApiKey = (apiKey: IApiKey) =>
    request.post<{ id: string }>('/api-keys', apiKey);

  return { apiKeys, getApiKeys, addApiKey };
}

function isActive(date: string | undefined, now: Moment) {
  if (date) {    
    return strToMoment(date) > now;
  }

  return false;
}